import React, { useEffect, useRef, useState } from "react"
import { isDesktop } from "react-device-detect"
import { connect } from "react-redux"
import { getApiBaseUrl } from "../../../shared_component/utils/urlUtils"
import SearchOnMap from "./SearchOnMap"
import { getFuelcardUsaaFlag } from "../../../v1/constants/fuelcardRequest"
import { withRouter } from "react-router-dom"
import { routerPaths } from "../../../v1/constants/paths"
import store from "../../../shared_component/utils/configureStore"
import Notifications from "../../../v1/components/Notifications"
import { isUsaaUser } from "../../../v1/helpers/affiliationHelpers"
import FuelcardRequest from "../Dashboard/FuelcardRequest"
import SwitchMap from "../MapBox/SwitchMap"

const FuelPage = ({ flutterApp, user, history }) => {
  const hostElementRef = useRef(null)
  const errorRef = useRef(null)
  const requestCardRef = useRef(null)

  const [increaseHeight, setHeight] = useState(false)

  const showError = (err) => {
    store.dispatch(
      Notifications.error({
        message: err,
        position: "tr",
        autoDismiss: 5,
        action: {
          label: "Dismiss"
        }
      })
    )
  }

  const handleFuelCardSplitFlag = async () => {
    try {
      const flag = await getFuelcardUsaaFlag()
      if (!flag) {
        history.push({
          pathname: routerPaths.dashboard
        })
      }
    } catch (error) {
      console.log("Error in handleFuelCardFlag", error)
    }
  }

  const changeHeight = (increaseHeight) => {
    setHeight(increaseHeight)
  }

  useEffect(() => {
    handleFuelCardSplitFlag()
    const baseURL = getApiBaseUrl()

    window._errorScreenInit = () => {
      window._errorScreenInit = () => {}
      errorRef.current = window._errorScreen
      errorRef.current.listenShowError(showError)
    }

    window._fuelWalletScreenInit = () => {
      window._fuelWalletScreenInit = () => {}
      requestCardRef.current = window._fuelWalletScreen
      requestCardRef.current.listenModalHeightChange(changeHeight)
      // requestCardRef.current.listenRequestCard(() => {})
      // requestCardRef.current.listenLearnMore(() => {})
    }

    if (flutterApp && hostElementRef.current) {
      const data = {
        auth_token: user.authentication_token,
        isDesktop: isDesktop,
        baseURL: baseURL
      }
      flutterApp.addView({
        hostElement: hostElementRef.current,
        initialData: {
          widget: "fuel_wallet",
          data: JSON.stringify(data)
        }
      })
    }
  }, [flutterApp])

  return (
    <div className="fuel-main-container">
      {/* Will only be rendered for USAA */}
      {user?.id && isUsaaUser(user) && (
        <div className="fuel-page-banner">
          <FuelcardRequest showCardLockedBanner={false} />
        </div>
      )}
      <div className="fuel-container">
        <div className="fuel-shop-list">
          <div className={increaseHeight ? "increase-height" : ""} ref={hostElementRef} />
        </div>
        <div className="fuel-map-view">
          <SwitchMap defaultActiveIndex={1} />
        </div>
      </div>
    </div>
  )
}

function mapStateToProps(state) {
  const { flutterApp } = state.flutterInit
  const user = state.user || {}

  return {
    flutterApp: flutterApp,
    user: user
  }
}

export default withRouter(connect(mapStateToProps)(FuelPage))
